<app-sidebar *ngIf="!isResponsive"></app-sidebar>
<div class="{{ project }}__sidebar__layout">
  <app-header *ngIf="header?.show"></app-header>
  <router-outlet></router-outlet>
</div>
